"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = props => _react.default.createElement(_SvgIcon.default, {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
}, _react.default.createElement("polygon", {
  fill: "#0666B0",
  points: "14 34 30 34 30 14 14 14"
}), _react.default.createElement("polygon", {
  fill: "#D94453",
  points: "14 50 30 50 30 38 14 38"
}), _react.default.createElement("polygon", {
  fill: "#666666",
  points: "34 50 50 50 50 30 34 30"
}), _react.default.createElement("polygon", {
  fill: "#CCCCCC",
  points: "34 14 34 26 50 26 50 14"
}));

exports.default = _default;
module.exports = exports.default;